import { GROUP_ROLES } from "statics.json";

const is = (role) => (member) => member?.role === role;

const hasAnyRole = (member) => member?.role || member?.roles?.length > 0;
const isMember = is(GROUP_ROLES.MEMBER);
const isAdmin = is(GROUP_ROLES.ADMIN);

export { hasAnyRole, isMember, isAdmin };
